import React from 'react';

import { SidebarAddPostTips } from './SidebarAddPostTips';

/**
 * Список советов для создания поста блога в сайдбаре
 */
export const SidebarAddBlogPostTips = () => {
  const items = [
    'Спросите о юридических тонкостях в сделках с недвижимостью',
    'Расскажите о своей ситуации и получите советы от профессионалов рынка',
    'Попросите оценить стоимость вашего объекта',
  ];

  return <SidebarAddPostTips title="О чём спросить" items={items} />;
};
